<template>
	<div class="featured-products" data-cy="featured-products">
		<h2 class="featured-products__title">Featured Products</h2>
		<div v-if="products.length" class="featured-products__products">
			<router-link
				v-for="(product, index) in products"
				class="product"
				:to="{ name: 'products', query: { class: product.class } }"
				:key="index"
				:data-cy="computedCypress(product.class)"
			>
				<div class="product__image-wrapper">
					<img :src="product.imageUrl" class="product__image" />
				</div>
				<h3 class="product__class">{{ product.class }}</h3>
			</router-link>
		</div>
		<Loading v-else :full="false" :small="true" />
	</div>
</template>

<script>
import Loading from '@/components/shared/Loading';

export default {
	methods: {
		computedCypress(productClass) {
			return `featured-product-${productClass}`;
		}
	},
	computed: {
		products() {
			const productData = this.$store.Product.productData;
			const products = [];

			// Loop through all of the product classes and get the first product for each class
			Object.keys(productData).forEach(productClass => {
				// Check to see if there is product data
				if (productData[productClass].products && productData[productClass].products.length) {
					let product;
					// We want a specific product for sedona, otherwise show the first product
					if (productClass === 'Sedona') {
						product = productData[productClass].products.find(item => item.size === '30 oz');
					} else {
						product = productData[productClass].products[0];
					}

					// Set the product class to be viewed by the user
					product.class = productClass;
					// Add the first product to the array
					products.push(product);
				}
			});

			return products;
		}
	},
	components: {
		Loading
	}
};
</script>

<style lang="scss" scoped>
@import '@/styles/mixins/brand-container.scss';
@import '@/styles/mixins/brand-fonts.scss';

.featured-products {
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	background-color: $brand-gray-100;
	padding: 40px 0 108px;
	&__title {
		@include Brand-H11();
		color: $brand-gray-400;
		margin-bottom: 24px;
	}
	&__products {
		@include Brand-Container(md);
		display: flex;
		flex-wrap: wrap;
		width: 100%;
		margin: 0 -10px;
		.product {
			background: $brand-tan;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			margin: 0 10px 24px;
			&:hover {
				background: #d4d3d1;
			}
			width: calc(50% - 20px);

			@include media-breakpoint-up(lg) {
				flex: 1;
			}
			&__image-wrapper {
				overflow: hidden;
				height: 200px;
				@include media-breakpoint-up(lg) {
					height: 360px;
				}
			}
			&__image {
				height: 100%;
			}
			&__class {
				@include Brand-H16();
				color: $brand-gray-400;
				margin: 22px 0 36px;
			}
		}
	}
}
</style>
